import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_AWARD_SUPPLIERS = graphql(/* GraphQL */ `
  mutation ContractDemandAwardSuppliers($id: UUID!, $data: TsrctContractDemandAwardsInput!) {
    tesseract {
      contractDemand(id: $id) {
        awardSuppliers(data: $data) {
          id
        }
      }
    }
  }
`);
